import React from 'react';
import {createRoot} from 'react-dom/client';
import {QueryClient, QueryClientProvider} from 'react-query';
import {PageConfigProvider} from 'libs/pageConfig';
import {GlobalLoaderManagerProvider} from 'libs/globalLoaderManager';
import {ModalManagerProvider} from 'libs/modalManager';
import ModalContainer from 'components/ModalContainer';
import GlobalStyle from './globalStyle';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {GoogleOAuthProvider} from "@react-oauth/google";
import {BrowserRouter} from "react-router-dom";
import {createTheme, CssBaseline, StyledEngineProvider} from "@mui/material";
import {ThemeProvider} from 'styled-components';
import {ThemeProvider as MuiThemeProvider} from "@mui/material/styles";
import ErrorHandler from "./libs/ErrorHandler";
import MlibComponents from "@lb/mlib-components";

const themeLight = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#d3d3d3",
        }
      }
    }
  }
});

const styledTheme = {
  ...themeLight,
  breakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const providers = [
  ErrorHandler,
  (props) => <StyledEngineProvider {...props} injectFirst/>,
  ({children, ...rest}) => <MuiThemeProvider {...rest} theme={themeLight}><CssBaseline/>{children}</MuiThemeProvider>,
  ({children, ...rest}) => <ThemeProvider {...rest} theme={styledTheme}><GlobalStyle/>{children}</ThemeProvider>,
  PageConfigProvider,
  GlobalLoaderManagerProvider,
  MlibComponents,
  ({children, ...rest}) => <ModalManagerProvider {...rest}>{children}<ModalContainer/></ModalManagerProvider>,
  (props) => <QueryClientProvider {...props} client={queryClient}/>,
  ({children, ...rest}) =>
    <GoogleOAuthProvider clientId={'674869190121-bqu1soou4ad2bk4frpbl8olus8bjv29e.apps.googleusercontent.com'}
                         {...rest} children={children}/>
];

function renderApp() {
  let content = <App/>;
  [...providers].reverse().map(Component => content = <Component>{content}</Component>);
  return <BrowserRouter>{content}</BrowserRouter>;
}

// React 18 introduces a new root API which provides better ergonomics for managing roots.
const container = document.getElementById('root');
const root = createRoot(container)
root.render(<React.StrictMode>{renderApp()}</React.StrictMode>)

// ReactDOM.render(
//   <StrictMode>
//     {renderApp()}
//   </StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
